import {
    DEFAULT_DOWN_ARROW,
    DEFAULT_NEGATIVE_COLOR,
    DEFAULT_NEUTRAL_COLOR,
    DEFAULT_POSITIVE_COLOR,
    DEFAULT_UP_ARROW,
} from '@dat/datiq-components-pkg/utils';

import { IDatiqCellChange } from '../models';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DatiqCellChangeService {
    constructor() {}

    getColor(settings: IDatiqCellChange): string {
        return this.isPositive(settings)
            ? this.getPositiveColor(settings)
            : this.isNegative(settings)
            ? this.getNegativeColor(settings)
            : this.getNeutralColor(settings);
    }

    isPositive(settings: IDatiqCellChange): boolean {
        return settings?.value > 0;
    }

    getPositiveColor(settings: IDatiqCellChange): string {
        return !!settings?.positiveColor
            ? settings.positiveColor
            : DEFAULT_POSITIVE_COLOR;
    }

    isNegative(settings: IDatiqCellChange): boolean {
        return settings?.value < 0;
    }

    getNegativeColor(settings: IDatiqCellChange): string {
        return !!settings?.negativeColor
            ? settings?.negativeColor
            : DEFAULT_NEGATIVE_COLOR;
    }

    getNeutralColor(settings: IDatiqCellChange): string {
        return !!settings?.neutralColor
            ? settings?.neutralColor
            : DEFAULT_NEUTRAL_COLOR;
    }

    getIcon(settings: IDatiqCellChange): string {
        return this.isPositive(settings)
            ? this.getPositiveIcon(settings)
            : this.isNegative(settings)
            ? this.getNegativeIcon(settings)
            : this.getNeutralIcon(settings);
    }

    getPositiveIcon(settings: IDatiqCellChange): string {
        return !!settings?.positiveIcon
            ? settings?.positiveIcon
            : DEFAULT_UP_ARROW;
    }
    getNegativeIcon(settings: IDatiqCellChange): string {
        return !!settings?.negativeIcon
            ? settings?.negativeIcon
            : DEFAULT_DOWN_ARROW;
    }
    getNeutralIcon(settings: IDatiqCellChange): string {
        return !!settings?.neutralIcon ? settings?.neutralIcon : '';
    }
}
